/**
 * PATH: packages/ui/src/components/settings/security-tab/SecurityTips.tsx
 * PURPOSE: Static security tips section displayed at the bottom of the Security tab.
 * WHY: Extracted from SecurityTab to keep each file under 300 lines.
 */

import { Key, Check } from 'lucide-react'

const TIPS = [
  'Use a unique, strong password for your Quotech account',
  'Enable two-factor authentication for additional security',
  'Review your active sessions regularly',
  'Never share your backup codes with anyone',
] as const

export function SecurityTips() {
  return (
    <section className="p-4 rounded-xl bg-muted/30 border border-border">
      <h4 className="font-medium mb-3 flex items-center gap-2">
        <Key className="w-4 h-4" />
        Security Tips
      </h4>
      <ul className="space-y-2 text-sm text-muted-foreground">
        {TIPS.map((tip) => (
          <li key={tip} className="flex items-start gap-2">
            <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" />
            {tip}
          </li>
        ))}
      </ul>
    </section>
  )
}
